import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import Form from './form';

interface AccordionResidenceProps {
  praticaKey?: {
    cdEnte: string;
    tipoPratica: string;
    idAnnoPratica: number;
    pgPratica: number;
  } | null;
}

const AccordionResidenceComponent = ({
  praticaKey,
}: AccordionResidenceProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-new-residence-content"
          id="panel-new-residence-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Nuova Residenza</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form praticaKey={praticaKey} />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionResidenceComponent.displayName = 'Accordion Residence';

const AccordionResidence = memo(AccordionResidenceComponent);

export default AccordionResidence;
